<template>
  <div class="nav-menu">
    <div class="nav-header">
      <div class="logo-container" @click="goToHome">
        <img src="@/assets/logo.png" alt="KamZi" class="logo" />
      </div>
      <!-- 移动端汉堡按钮 -->
      <button
        class="mobile-menu-btn"
        type="button"
        :aria-label="$t('common.menu')"
        @click="drawerVisible = true"
      >
        <i class="el-icon-menu" aria-hidden="true"></i>
      </button>
      <!-- PC端菜单 -->
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo pc-menu"
        mode="horizontal"
        background-color="#fff"
        text-color="#333"
        active-text-color="#ff6b00"
        router
      >
        <el-menu-item index="/">{{ $t("common.home") }}</el-menu-item>
        <el-submenu index="models">
          <template slot="title">{{ $t("common.models") }}</template>
          <el-submenu index="models-nisshinbo">
            <template slot="title">{{ $t("common.nisshinbo") }}</template>

            <!-- 音频IC -->
            <el-submenu index="audio-ics">
              <template slot="title">{{ $t("models.audioICs") }}</template>
              <el-menu-item index="/models/audio-amplifier">{{
                $t("models.audioAmplifier")
              }}</el-menu-item>
              <el-menu-item index="/models/audio-signal-processor">{{
                $t("models.audioSignalProcessor")
              }}</el-menu-item>
              <el-menu-item index="/models/audio-switch">{{
                $t("models.audioSwitch")
              }}</el-menu-item>
              <el-menu-item index="/models/mems-transducer">{{
                $t("models.memsTransducer")
              }}</el-menu-item>
              <el-menu-item index="/models/mems-microphone-amplifiers">{{
                $t("models.memsMicrophoneAmplifiers")
              }}</el-menu-item>
              <el-menu-item index="/models/audio-video-misc">{{
                $t("models.audioVideoMisc")
              }}</el-menu-item>
            </el-submenu>

            <!-- 视频IC -->
            <el-submenu index="video-ics">
              <template slot="title">{{ $t("models.videoICs") }}</template>
              <el-menu-item index="/models/video-ic">{{
                $t("models.videoIC")
              }}</el-menu-item>
            </el-submenu>

            <!-- 电源管理IC -->
            <el-submenu index="power-management-ics">
              <template slot="title">{{
                $t("models.powerManagementICs")
              }}</template>
              <el-menu-item index="/models/ldo-linear-regulator">{{
                $t("models.ldoLinearRegulator")
              }}</el-menu-item>
              <el-menu-item index="/models/dcdc-switching-regulator">{{
                $t("models.dcdcSwitchingRegulator")
              }}</el-menu-item>
              <el-menu-item index="/models/pmics">{{
                $t("models.pmics")
              }}</el-menu-item>
              <el-menu-item index="/models/shunt-regulators">{{
                $t("models.shuntRegulators")
              }}</el-menu-item>
              <el-menu-item index="/models/charge-pumps">{{
                $t("models.chargePumps")
              }}</el-menu-item>
              <el-menu-item index="/models/voltage-detector">{{
                $t("models.voltageDetector")
              }}</el-menu-item>
              <el-menu-item index="/models/reset-timer">{{
                $t("models.resetTimer")
              }}</el-menu-item>
            </el-submenu>

            <!-- 电池管理IC -->
            <el-submenu index="battery-management-ics">
              <template slot="title">{{
                $t("models.batteryManagementICs")
              }}</template>
              <el-menu-item index="/models/li-ion-battery">{{
                $t("models.liIonBattery")
              }}</el-menu-item>
              <el-menu-item index="/models/battery-charger">{{
                $t("models.batteryCharger")
              }}</el-menu-item>
              <el-menu-item index="/models/battery-backup">{{
                $t("models.batteryBackup")
              }}</el-menu-item>
            </el-submenu>

            <!-- 开关驱动IC -->
            <el-submenu index="switching-driver-ics">
              <template slot="title">{{
                $t("models.switchingDriverICs")
              }}</template>
              <el-menu-item index="/models/switching-drivers-gate">{{
                $t("models.switchingDriversGate")
              }}</el-menu-item>
              <el-menu-item index="/models/switching-drivers-half">{{
                $t("models.switchingDriversHalf")
              }}</el-menu-item>
              <el-menu-item index="/models/switching-drivers-wboost">{{
                $t("models.switchingDriversWboost")
              }}</el-menu-item>
              <el-menu-item index="/models/switching-ics">{{
                $t("models.switchingICs")
              }}</el-menu-item>
            </el-submenu>

            <!-- 信号处理IC -->
            <el-submenu index="signal-processing-ics">
              <template slot="title">{{
                $t("models.signalProcessingICs")
              }}</template>
              <el-menu-item index="/models/amplifier">{{
                $t("models.amplifier")
              }}</el-menu-item>
              <el-menu-item index="/models/comparator">{{
                $t("models.comparator")
              }}</el-menu-item>
              <el-menu-item index="/models/sensor-monitoring-afe">{{
                $t("models.sensorMonitoringAfe")
              }}</el-menu-item>
              <el-menu-item index="/models/data-converter">{{
                $t("models.dataConverter")
              }}</el-menu-item>
              <el-menu-item index="/models/low-noise-amplifier">{{
                $t("models.lowNoiseAmplifier")
              }}</el-menu-item>
              <el-menu-item index="/models/saw-filter">{{
                $t("models.sawFilter")
              }}</el-menu-item>
              <el-menu-item index="/models/fm-if-demodulator">{{
                $t("models.fmIfDemodulator")
              }}</el-menu-item>
              <el-menu-item index="/models/amplifier-pll">{{
                $t("models.amplifierPLL")
              }}</el-menu-item>
              <el-menu-item index="/models/modulation-demodulation-mixer">{{
                $t("models.modulationDemodulationMixer")
              }}</el-menu-item>
            </el-submenu>

            <!-- 接口与控制IC -->
            <el-submenu index="interface-control-ics">
              <template slot="title">{{
                $t("models.interfaceControlICs")
              }}</template>
              <el-menu-item index="/models/io-link">{{
                $t("models.ioLink")
              }}</el-menu-item>
              <el-menu-item index="/models/led-controller">{{
                $t("models.ledController")
              }}</el-menu-item>
              <el-menu-item index="/models/ssfm-oscillator">{{
                $t("models.ssfmOscillator")
              }}</el-menu-item>
              <el-menu-item index="/models/rf-switch">{{
                $t("models.rfSwitch")
              }}</el-menu-item>
              <el-menu-item index="/models/stepper-motor-driver">{{
                $t("models.stepperMotorDriver")
              }}</el-menu-item>
              <el-menu-item index="/models/three-phase-bldc">{{
                $t("models.threePhaseBLDC")
              }}</el-menu-item>
              <el-menu-item index="/models/single-phase-bldc">{{
                $t("models.singlePhaseBLDC")
              }}</el-menu-item>
              <el-menu-item index="/models/actuator-gate-drivers">{{
                $t("models.actuatorGateDrivers")
              }}</el-menu-item>
              <el-menu-item index="/models/io-port-expansion">{{
                $t("models.ioPortExpansion")
              }}</el-menu-item>
              <el-menu-item index="/models/other-peripheral-ics">{{
                $t("models.otherPeripheralICs")
              }}</el-menu-item>
            </el-submenu>

            <!-- 特殊功能IC -->
            <el-submenu index="special-function-ics">
              <template slot="title">{{
                $t("models.specialFunctionICs")
              }}</template>
              <el-menu-item index="/models/real-time-clock">{{
                $t("models.realTimeClock")
              }}</el-menu-item>
              <el-menu-item index="/models/quartz-crystal-oscillator">{{
                $t("models.quartzCrystalOscillator")
              }}</el-menu-item>
              <el-menu-item index="/models/ate-assps">{{
                $t("models.ateAssps")
              }}</el-menu-item>
              <el-menu-item index="/models/lcd-drivers">{{
                $t("models.lcdDrivers")
              }}</el-menu-item>
              <el-menu-item index="/models/ld-driver-ics">{{
                $t("models.ldDriverICs")
              }}</el-menu-item>
              <el-menu-item index="/models/analog-switches">{{
                $t("models.analogSwitches")
              }}</el-menu-item>
              <el-menu-item index="/models/special">{{
                $t("models.special")
              }}</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="models-feihong">
            <template slot="title">{{ $t("common.feihong") }}</template>
            <el-menu-item index="/models/feihong">{{
              $t("models.feihongProducts")
            }}</el-menu-item>
          </el-submenu>
          <el-submenu index="models-ketianshi">
            <template slot="title">{{ $t("common.ketianshi") }}</template>
            <el-menu-item index="/models/ketianshi">{{
              $t("models.ketianshiProducts")
            }}</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-menu-item index="/agent-brands">{{
          $t("common.agentBrands")
        }}</el-menu-item>
        <el-menu-item index="/dealer-brands">{{
          $t("common.dealerBrands")
        }}</el-menu-item>
        <el-menu-item index="/contact">{{ $t("common.contact") }}</el-menu-item>
      </el-menu>
      <!-- 语言与搜索：顶栏右侧，同属 nav-header -->
      <div class="nav-header-right">
        <lang-switcher></lang-switcher>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="small"
          class="nav-search-btn"
          @click="goToSearch"
        >
          <span :visible="drawerVisible">{{ $t("common.search") }}</span>
        </el-button>
      </div>
    </div>
    <!-- 移动端抽屉菜单 -->
    <el-drawer
      :visible.sync="drawerVisible"
      direction="ltr"
      size="min(88vw, 360px)"
      class="mobile-drawer"
    >
      <el-menu
        :default-active="activeIndex"
        class="mobile-drawer-menu"
        mode="vertical"
        background-color="#fff"
        text-color="#333"
        active-text-color="#ff6b00"
        router
        @select="drawerVisible = false"
      >
        <el-menu-item index="/">{{ $t("common.home") }}</el-menu-item>
        <el-submenu index="models">
          <template slot="title">{{ $t("common.models") }}</template>
          <el-submenu index="models-nisshinbo">
            <template slot="title">{{ $t("common.nisshinbo") }}</template>

            <!-- 音频IC -->
            <el-submenu index="audio-ics">
              <template slot="title">{{ $t("models.audioICs") }}</template>
              <el-menu-item index="/models/audio-amplifier">{{
                $t("models.audioAmplifier")
              }}</el-menu-item>
              <el-menu-item index="/models/audio-signal-processor">{{
                $t("models.audioSignalProcessor")
              }}</el-menu-item>
              <el-menu-item index="/models/audio-switch">{{
                $t("models.audioSwitch")
              }}</el-menu-item>
              <el-menu-item index="/models/mems-transducer">{{
                $t("models.memsTransducer")
              }}</el-menu-item>
              <el-menu-item index="/models/mems-microphone-amplifiers">{{
                $t("models.memsMicrophoneAmplifiers")
              }}</el-menu-item>
              <el-menu-item index="/models/audio-video-misc">{{
                $t("models.audioVideoMisc")
              }}</el-menu-item>
            </el-submenu>

            <!-- 视频IC -->
            <el-submenu index="video-ics">
              <template slot="title">{{ $t("models.videoICs") }}</template>
              <el-menu-item index="/models/video-ic">{{
                $t("models.videoIC")
              }}</el-menu-item>
            </el-submenu>

            <!-- 电源管理IC -->
            <el-submenu index="power-management-ics">
              <template slot="title">{{
                $t("models.powerManagementICs")
              }}</template>
              <el-menu-item index="/models/ldo-linear-regulator">{{
                $t("models.ldoLinearRegulator")
              }}</el-menu-item>
              <el-menu-item index="/models/dcdc-switching-regulator">{{
                $t("models.dcdcSwitchingRegulator")
              }}</el-menu-item>
              <el-menu-item index="/models/pmics">{{
                $t("models.pmics")
              }}</el-menu-item>
              <el-menu-item index="/models/shunt-regulators">{{
                $t("models.shuntRegulators")
              }}</el-menu-item>
              <el-menu-item index="/models/charge-pumps">{{
                $t("models.chargePumps")
              }}</el-menu-item>
              <el-menu-item index="/models/voltage-detector">{{
                $t("models.voltageDetector")
              }}</el-menu-item>
              <el-menu-item index="/models/reset-timer">{{
                $t("models.resetTimer")
              }}</el-menu-item>
            </el-submenu>

            <!-- 电池管理IC -->
            <el-submenu index="battery-management-ics">
              <template slot="title">{{
                $t("models.batteryManagementICs")
              }}</template>
              <el-menu-item index="/models/li-ion-battery">{{
                $t("models.liIonBattery")
              }}</el-menu-item>
              <el-menu-item index="/models/battery-charger">{{
                $t("models.batteryCharger")
              }}</el-menu-item>
              <el-menu-item index="/models/battery-backup">{{
                $t("models.batteryBackup")
              }}</el-menu-item>
            </el-submenu>

            <!-- 开关驱动IC -->
            <el-submenu index="switching-driver-ics">
              <template slot="title">{{
                $t("models.switchingDriverICs")
              }}</template>
              <el-menu-item index="/models/switching-drivers-gate">{{
                $t("models.switchingDriversGate")
              }}</el-menu-item>
              <el-menu-item index="/models/switching-drivers-half">{{
                $t("models.switchingDriversHalf")
              }}</el-menu-item>
              <el-menu-item index="/models/switching-drivers-wboost">{{
                $t("models.switchingDriversWboost")
              }}</el-menu-item>
              <el-menu-item index="/models/switching-ics">{{
                $t("models.switchingICs")
              }}</el-menu-item>
            </el-submenu>

            <!-- 信号处理IC -->
            <el-submenu index="signal-processing-ics">
              <template slot="title">{{
                $t("models.signalProcessingICs")
              }}</template>
              <el-menu-item index="/models/amplifier">{{
                $t("models.amplifier")
              }}</el-menu-item>
              <el-menu-item index="/models/comparator">{{
                $t("models.comparator")
              }}</el-menu-item>
              <el-menu-item index="/models/sensor-monitoring-afe">{{
                $t("models.sensorMonitoringAfe")
              }}</el-menu-item>
              <el-menu-item index="/models/data-converter">{{
                $t("models.dataConverter")
              }}</el-menu-item>
              <el-menu-item index="/models/low-noise-amplifier">{{
                $t("models.lowNoiseAmplifier")
              }}</el-menu-item>
              <el-menu-item index="/models/saw-filter">{{
                $t("models.sawFilter")
              }}</el-menu-item>
              <el-menu-item index="/models/fm-if-demodulator">{{
                $t("models.fmIfDemodulator")
              }}</el-menu-item>
              <el-menu-item index="/models/amplifier-pll">{{
                $t("models.amplifierPLL")
              }}</el-menu-item>
              <el-menu-item index="/models/modulation-demodulation-mixer">{{
                $t("models.modulationDemodulationMixer")
              }}</el-menu-item>
            </el-submenu>

            <!-- 接口与控制IC -->
            <el-submenu index="interface-control-ics">
              <template slot="title">{{
                $t("models.interfaceControlICs")
              }}</template>
              <el-menu-item index="/models/io-link">{{
                $t("models.ioLink")
              }}</el-menu-item>
              <el-menu-item index="/models/led-controller">{{
                $t("models.ledController")
              }}</el-menu-item>
              <el-menu-item index="/models/ssfm-oscillator">{{
                $t("models.ssfmOscillator")
              }}</el-menu-item>
              <el-menu-item index="/models/rf-switch">{{
                $t("models.rfSwitch")
              }}</el-menu-item>
              <el-menu-item index="/models/stepper-motor-driver">{{
                $t("models.stepperMotorDriver")
              }}</el-menu-item>
              <el-menu-item index="/models/three-phase-bldc">{{
                $t("models.threePhaseBLDC")
              }}</el-menu-item>
              <el-menu-item index="/models/single-phase-bldc">{{
                $t("models.singlePhaseBLDC")
              }}</el-menu-item>
              <el-menu-item index="/models/actuator-gate-drivers">{{
                $t("models.actuatorGateDrivers")
              }}</el-menu-item>
              <el-menu-item index="/models/io-port-expansion">{{
                $t("models.ioPortExpansion")
              }}</el-menu-item>
              <el-menu-item index="/models/other-peripheral-ics">{{
                $t("models.otherPeripheralICs")
              }}</el-menu-item>
            </el-submenu>

            <!-- 特殊功能IC -->
            <el-submenu index="special-function-ics">
              <template slot="title">{{
                $t("models.specialFunctionICs")
              }}</template>
              <el-menu-item index="/models/real-time-clock">{{
                $t("models.realTimeClock")
              }}</el-menu-item>
              <el-menu-item index="/models/quartz-crystal-oscillator">{{
                $t("models.quartzCrystalOscillator")
              }}</el-menu-item>
              <el-menu-item index="/models/ate-assps">{{
                $t("models.ateAssps")
              }}</el-menu-item>
              <el-menu-item index="/models/lcd-drivers">{{
                $t("models.lcdDrivers")
              }}</el-menu-item>
              <el-menu-item index="/models/ld-driver-ics">{{
                $t("models.ldDriverICs")
              }}</el-menu-item>
              <el-menu-item index="/models/analog-switches">{{
                $t("models.analogSwitches")
              }}</el-menu-item>
              <el-menu-item index="/models/special">{{
                $t("models.special")
              }}</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="models-feihong">
            <template slot="title">{{ $t("common.feihong") }}</template>
            <el-menu-item index="/models/feihong">{{
              $t("models.feihongProducts")
            }}</el-menu-item>
          </el-submenu>
          <el-submenu index="models-ketianshi">
            <template slot="title">{{ $t("common.ketianshi") }}</template>
            <el-menu-item index="/models/ketianshi">{{
              $t("models.ketianshiProducts")
            }}</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-menu-item index="/agent-brands">{{
          $t("common.agentBrands")
        }}</el-menu-item>
        <el-menu-item index="/dealer-brands">{{
          $t("common.dealerBrands")
        }}</el-menu-item>
        <el-menu-item index="/contact">{{ $t("common.contact") }}</el-menu-item>
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
/**
 * 导航菜单组件
 * @component NavMenu
 */
import LangSwitcher from "./LangSwitcher.vue";

export default {
  name: "NavMenu",
  components: {
    LangSwitcher,
  },
  data() {
    return {
      activeIndex: "/",
      drawerVisible: false,
    };
  },
  computed: {
    /**
     * @description 获取当前激活的菜单项
     */
    currentActiveIndex() {
      const path = this.$route.path;
      // 如果是型号相关的路径，返回 'models'
      if (path.startsWith("/models")) {
        return "models";
      }
      return path;
    },
  },
  watch: {
    $route() {
      this.activeIndex = this.currentActiveIndex;
    },
  },
  mounted() {
    this.activeIndex = this.currentActiveIndex;
  },
  methods: {
    /**
     * @description 跳转至首页
     * @returns {void}
     */
    goToHome() {
      if (this.$route.path === "/") {
        return;
      }
      this.$router.push("/").catch(() => {
        // 捕获重复导航的错误，避免控制台警告
      });
    },
    /**
     * @description 跳转至型号列表页（产品搜索）
     * @returns {void}
     */
    goToSearch() {
      // 如果当前路由已经是 Search，则直接返回，不进行跳转
      if (this.$route.name === "Search") {
        return;
      }
      this.$router.push({ name: "Search" });
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-menu {
  .nav-header {
    display: flex;
    align-items: center;
    padding: 0 60px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .logo-container {
    margin-right: 20px;
    cursor: pointer;

    .logo {
      height: 50px;
      margin: 5px 0;
    }
  }

  .el-menu {
    flex: 1;
    display: flex;
    border-bottom: none;

    .el-menu-item {
      font-size: 16px;
      font-weight: 500;
      padding: 0 20px;
      height: 60px;
      line-height: 60px;

      &:hover {
        background-color: #fff5f0 !important;
      }
    }
  }

  .nav-header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
    flex-shrink: 0;
    gap: 12px;
  }

  .nav-search-btn {
    flex-shrink: 0;
  }
}
.mobile-menu-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #333;
  margin-left: 10px;

  i {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .pc-menu {
    display: none !important;
  }
  .mobile-menu-btn {
    display: inline-flex;
  }
  .nav-menu .nav-header {
    min-height: 60px;
    padding: 0 16px;
  }
  .nav-menu .logo-container {
    margin-right: 0;
  }
  .nav-menu .logo-container .logo {
    height: 40px;
  }
  .nav-menu .nav-header-right {
    gap: 4px;
  }
  .nav-menu .nav-search-btn {
    width: 44px;
    padding: 0;

    span {
      display: none;
    }
  }
  .nav-header-right {
    margin-left: auto;
  }
}
.mobile-drawer {
  .el-menu {
    border: none;
  }
}
</style>
<style>
.el-submenu__title {
  font-size: 16px !important;
  font-weight: 500 !important;
  text-align: center;
}

/* 修复多级菜单文本与箭头重叠问题 */
.el-submenu .el-submenu__title {
  padding-right: 40px !important;
  min-width: 200px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* 确保箭头图标有足够的空间 */
.el-submenu .el-submenu__icon-arrow {
  position: absolute !important;
  right: 15px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin-left: 0 !important;
}

/* 针对水平菜单的特殊处理 */
.el-menu--horizontal .el-submenu .el-submenu__title {
  min-width: 180px !important;
  padding-right: 35px !important;
}

.el-menu--horizontal .el-submenu .el-submenu__icon-arrow {
  right: 12px !important;
}

/* 针对垂直菜单（移动端）的处理 */
.el-menu--vertical .el-submenu .el-submenu__title {
  min-width: 220px !important;
  padding-right: 45px !important;
}

.el-menu--vertical .el-submenu .el-submenu__icon-arrow {
  right: 18px !important;
}

/* 确保子菜单项有足够的宽度 */
.el-submenu .el-menu {
  min-width: 250px !important;
}

.el-submenu .el-menu-item {
  min-width: 250px !important;
  padding-right: 20px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* 响应式处理 - 小屏幕设备 */
@media (max-width: 768px) {
  .el-submenu .el-submenu__title {
    min-width: 0 !important;
    height: auto !important;
    min-height: 48px !important;
    padding: 12px 40px 12px 20px !important;
    line-height: 1.45 !important;
    font-size: 14px !important;
    white-space: normal !important;
  }

  .el-submenu .el-menu-item {
    min-width: 0 !important;
    height: auto !important;
    min-height: 48px !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    line-height: 1.45 !important;
    font-size: 14px !important;
    white-space: normal !important;
  }

  .mobile-drawer .el-menu,
  .mobile-drawer .el-submenu .el-menu {
    min-width: 0 !important;
  }

  .mobile-drawer .el-drawer__body {
    overflow-y: auto;
  }

  .mobile-drawer .mobile-drawer-menu {
    display: block !important;
    width: 100%;
    padding: 8px 0 24px;
  }

  .mobile-drawer .mobile-drawer-menu .el-menu-item,
  .mobile-drawer .mobile-drawer-menu .el-submenu__title {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;
  }

  .mobile-drawer .mobile-drawer-menu > .el-menu-item,
  .mobile-drawer .mobile-drawer-menu > .el-submenu > .el-submenu__title {
    min-height: 52px !important;
    padding-left: 20px !important;
    font-size: 15px !important;
  }

  .mobile-drawer .mobile-drawer-menu .el-submenu .el-menu {
    width: 100%;
    background-color: #f7f8fa !important;
  }

  .mobile-drawer .mobile-drawer-menu .el-submenu .el-menu-item,
  .mobile-drawer .mobile-drawer-menu .el-submenu .el-submenu__title {
    padding-left: 36px !important;
  }

  .mobile-drawer .mobile-drawer-menu .el-submenu .el-submenu .el-menu-item,
  .mobile-drawer
    .mobile-drawer-menu
    .el-submenu
    .el-submenu
    .el-submenu__title {
    padding-left: 52px !important;
  }

  .mobile-drawer
    .mobile-drawer-menu
    .el-submenu
    .el-submenu
    .el-submenu
    .el-menu-item,
  .mobile-drawer
    .mobile-drawer-menu
    .el-submenu
    .el-submenu
    .el-submenu
    .el-submenu__title {
    padding-left: 68px !important;
  }
}

/* 响应式处理 - 中等屏幕设备 */
@media (min-width: 769px) and (max-width: 1024px) {
  .el-submenu .el-submenu__title {
    min-width: 190px !important;
    padding-right: 38px !important;
  }

  .el-submenu .el-menu-item {
    min-width: 220px !important;
  }
}

/* 响应式处理 - 大屏幕设备 */
@media (min-width: 1025px) {
  .el-submenu .el-submenu__title {
    min-width: 220px !important;
    padding-right: 42px !important;
  }

  .el-submenu .el-menu-item {
    min-width: 260px !important;
  }
}

/* 特别处理长文本的菜单项 */
.el-submenu .el-submenu__title[title*="Management"],
.el-submenu .el-submenu__title[title*="Processing"],
.el-submenu .el-submenu__title[title*="Interface"],
.el-submenu .el-submenu__title[title*="Switching"] {
  min-width: 240px !important;
  padding-right: 45px !important;
}

/* 确保下拉菜单的定位正确 */
.el-submenu .el-submenu__dropdown {
  min-width: 250px !important;
}

.el-submenu .el-submenu__dropdown .el-menu {
  min-width: 250px !important;
}
</style>
